<form
  (ngSubmit)="changePassword()"
  [formGroup]="form"
  class="tw:flex tw:flex-col tw:gap-4 tw:mt-4"
>
  <div class="tw:mb-2 tw:text-base tw:font-semibold">Create your password</div>
  <div class="tw:flex tw:items-center tw:flex-wrap tw:gap-2">
    @for (requirement of passwordRequirements; track requirement.rule) {
      @let isRuleDone = !hasError(requirement.errorName);
      <div
        [ngClass]="{
          'tw:rounded-(--p-content-border-radius) tw:bg-p-green-100': isRuleDone,
          'tw:rounded-[100px] tw:bg-bluegray-100': !isRuleDone,
        }"
        class="tw:py-1 tw:px-2 tw:flex tw:items-center tw:gap-2"
      >
        <div
          [ngClass]="{
            'tw:text-p-green-700': isRuleDone,
          }"
        >
          {{ requirement.label }}
        </div>
        <pinnakl-icon
          [ngClass]="{
            'tw:text-p-green-700': isRuleDone,
            'tw:text-bluegray-500': !isRuleDone,
          }"
          class="tw:flex tw:w-3 tw:h-3 tw:text-bluegray-400"
          name="check"
        />
      </div>
    }
  </div>

  <div>
    <prime-input-container>
      <ng-template #labelContent>
        <prime-label-content
          [control]="form.get('password')"
          label="New password"
        />
      </ng-template>
      <ng-template #inputContent>
        <prime-input-password
          [feedback]="false"
          [toggleMask]="true"
          autocomplete="new-password"
          class="tw:flex tw:w-full"
          [control]="form.get('password')"
          inputStyleClass="tw:w-full"
        />
      </ng-template>
      <ng-template #validationContent>
        <prime-input-validation
          [customErrors]="{
            lowercase: 'Password must contain at least one lowercase letter.',
            uppercase: 'Password must contain at least one uppercase letter.',
            digit: 'Password must contain at least one number.',
            symbol: 'Password must contain at least one symbol (!@#$%^&*).',
            length: 'Password must be at least 8 characters long.',
          }"
          class="tw:mt-1"
          [control]="form.get('password')"
        />
      </ng-template>
    </prime-input-container>
  </div>

  <div>
    <prime-input-container labelClasses="tw:mt-2">
      <ng-template #labelContent>
        <prime-label-content
          [control]="form.get('confirmation')"
          label="Confirm password"
        />
      </ng-template>
      <ng-template #inputContent>
        <prime-input-password
          [feedback]="false"
          [toggleMask]="true"
          autocomplete="new-password"
          class="tw:flex tw:w-full"
          [control]="form.get('confirmation')"
          inputStyleClass="tw:w-full"
        />
      </ng-template>
      <ng-template #validationContent>
        <prime-input-validation
          class="tw:mt-1"
          [control]="form.get('confirmation')"
        />
      </ng-template>
    </prime-input-container>
  </div>

  @if (!hideSubmit()) {
    <div class="tw:flex tw:justify-center tw:mt-2">
      <prime-button
        type="submit"
        label="Save"
      />
    </div>
  }
</form>
